import { render, staticRenderFns } from "./LayoutFullLight.vue?vue&type=template&id=b5805a44&"
import script from "./LayoutFullLight.vue?vue&type=script&lang=js&"
export * from "./LayoutFullLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports